import { createSelector } from '@ngrx/store';

import { getCollectionsState } from '../collections.reducer';

export const getAssociationLabel = createSelector(
  getCollectionsState,
  ({ associationLabel }, { jobId, candidateId }) => !!associationLabel[jobId] && !!associationLabel[jobId][candidateId]
    ? associationLabel[jobId][candidateId]
    : null
);
